
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate_search",
      function () {
        return require("private-next-pages/affiliate_search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate_search"])
      });
    }
  